import { useTranslation } from "react-i18next";

import Tag from "@components/shared/Tag";

type TrialRunTagProps = {
  status: "success" | "warning" | "error" | "ledgered";
};

const TrialRunTag: React.FunctionComponent<TrialRunTagProps> = ({ status }) => {
  const { t } = useTranslation();
  // "ledgered" marks a row already committed in a prior (partial) run — shown as a
  // distinct blue (info) badge so resuming an upload makes clear which rows are done
  // versus the green "Success" rows still waiting to be ledgered.
  return (
    <Tag status={status === "ledgered" ? "info" : status}>
      {status === "error"
        ? t("common.error")
        : status === "warning"
        ? t("common.warning")
        : status === "ledgered"
        ? t("common.ledgered")
        : t("common.success")}
    </Tag>
  );
};

export default TrialRunTag;
